import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useState } from "react";
import PropTypes from "prop-types";
import analytics from "web/script/analytics/analytics";
import { LanguageChoicePropType } from "web/types/language";
import classnames from "classnames";
import withReduxProvider from "web/react/redux-provider";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { setSelectedGender } from "web/redux/ducks/main-navigation";
import SlideContainer from "./main-navigation-slide-container/main-navigation-slide-container";
import MainNavigationGenderMenu from "./main-navigation-gender-menu/main-navigation-gender-menu";
import MainNavigationSubCategory from "./main-navigation-subcategory/main-navigation-subcategory";
import BurgerMenuCountrySelector from "./../burger-menu/burger-menu-country-selector-menu/burger-menu-country-selector-menu";
import LanguageSelector from "./../burger-menu/burger-menu-language-selector/burger-menu-language-selector";
import MainNavigationDesktop from "./main-navigation-desktop/main-navigation-desktop";
import styles from "./main-navigation.css";

function extractNavigation(state) {
  return state.mainNavigationReducer;
}

function GenderButton(_ref) {
  var title = _ref.title,
      isActive = _ref.isActive,
      onGenderClick = _ref.onGenderClick;
  return React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return onGenderClick();
    },
    className: classnames(styles.genderOption, _defineProperty({}, styles.genderActive, isActive))
  }, title);
}

GenderButton.propTypes = {
  title: PropTypes.string,
  isActive: PropTypes.bool,
  onGenderClick: PropTypes.func
};
export function MainNavigation(_ref2) {
  var data = _ref2.data,
      userGender = _ref2.userGender,
      showCountryPicker = _ref2.showCountryPicker,
      currentCountry = _ref2.currentCountry,
      currentCurrency = _ref2.currentCurrency,
      allCountries = _ref2.allCountries,
      languageSelector = _ref2.languageSelector,
      fullRender = _ref2.fullRender,
      featuredDesignersUrl = _ref2.featuredDesignersUrl;
  var dispatch = useDispatch();

  var _useReduxSelector = useReduxSelector(extractNavigation),
      visible = _useReduxSelector.visible,
      selectedGender = _useReduxSelector.selectedGender;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      categories = _useState2[0],
      setCategories = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      menuIndex = _useState4[0],
      setMenuIndex = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      renderCountries = _useState6[0],
      setRenderCountries = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      renderLanguages = _useState8[0],
      setRenderLanguages = _useState8[1];

  var genderMenuArray = [data.F, data.M];
  var COUNTRY_SLIDE = 1;
  var LANGUAGE_SLIDE = 2;
  var genders = {
    women: "F",
    men: "M"
  };
  var isWomenMenu;
  var currentLanguage = languageSelector.choices.find(function (language) {
    return language.is_selected === true;
  });

  function showNextCategory(nextCategory) {
    var newCategories = [].concat(_toConsumableArray(categories), [nextCategory]);
    setCategories(newCategories);
    setMenuIndex(newCategories.length);
    scrollToTop();
    analytics.event("nav", "clicked", "user_click_".concat(nextCategory.name));
  }

  function goBackCategory() {
    categories.pop();
    setMenuIndex(categories.length);
    setCategories(_toConsumableArray(categories));
    scrollToTop();
  }

  function scrollToTop() {
    var menuContent = document.getElementById("burgerMenuContent");

    if (menuContent !== null) {
      menuContent.scrollTop = 0;
    }
  }

  function showCountrySlide() {
    analytics.event("SETTINGS", "SHOW_COUNTRY_OVERLAY");
    setRenderCountries(true);
    setMenuIndex(COUNTRY_SLIDE);
    scrollToTop();
  }

  function hideCountrySlide() {
    setRenderCountries(false);
    setMenuIndex(0);
    scrollToTop();
  }

  function showLanguageSlide() {
    setRenderLanguages(true);
    setMenuIndex(LANGUAGE_SLIDE);
    scrollToTop();
  }

  function hideLanguageSlide() {
    setRenderLanguages(false);
    setMenuIndex(0);
    scrollToTop();
  } // Gender can be set from the request (userGender) or
  // from redux (selectedGender) by interacting with the navigation


  var currentGender = "women"; // default

  if (userGender) {
    currentGender = userGender.toLowerCase();
  }

  if (selectedGender !== "") {
    currentGender = selectedGender;
  }

  isWomenMenu = currentGender === "women";

  if (visible) {
    scrollToTop();
  }

  return React.createElement(React.Fragment, null, React.createElement("nav", {
    id: "burgerMenuContent",
    className: classnames(styles.nav, _defineProperty({}, styles.navOpen, visible)),
    "aria-label": "Lyst navigation menu"
  }, React.createElement(SlideContainer, {
    index: menuIndex
  }, React.createElement("div", null, React.createElement("div", {
    className: styles.genderSelector
  }, React.createElement(GenderButton, {
    title: data.F.display_name,
    isActive: isWomenMenu,
    onGenderClick: function onGenderClick() {
      dispatch(setSelectedGender("women"));
    }
  }), React.createElement(GenderButton, {
    title: data.M.display_name,
    isActive: !isWomenMenu,
    onGenderClick: function onGenderClick() {
      dispatch(setSelectedGender("men"));
    }
  })), React.createElement("div", {
    className: classnames(styles.genderMenuContainer, _defineProperty({}, styles.genderMenuSwitch, !isWomenMenu))
  }, genderMenuArray.map(function (genderMenu) {
    return React.createElement(MainNavigationGenderMenu, {
      key: genderMenu.display_name,
      menu: genderMenu,
      fullRender: fullRender,
      showCountryPicker: showCountryPicker,
      onCategoryClick: showNextCategory,
      onCountrySelectorClick: showCountrySlide,
      currentCountry: currentCountry,
      currentCurrency: currentCurrency,
      currentLanguage: currentLanguage,
      onLanguageSelectorClick: showLanguageSlide,
      showLanguageSelector: languageSelector.is_shown
    });
  }))), categories && categories.map(function (category) {
    return React.createElement(MainNavigationSubCategory, {
      key: category.display_name,
      title: category.display_name,
      submenu: category,
      show: true,
      onCategoryClick: showNextCategory,
      onClose: goBackCategory
    });
  }), renderCountries && React.createElement(BurgerMenuCountrySelector, {
    allCountries: allCountries,
    currentCountry: currentCountry,
    currentCurrency: currentCurrency,
    onBackToMainClick: hideCountrySlide
  }), renderLanguages && React.createElement(LanguageSelector, {
    allLanguages: languageSelector.choices,
    onBackToMainClick: hideLanguageSlide
  }))), React.createElement(MainNavigationDesktop, {
    menuData: data[genders[currentGender]],
    showContent: visible,
    featuredDesignersUrl: featuredDesignersUrl
  }));
}
MainNavigation.defaultProps = {
  data: [],
  userGender: "",
  showCountryPicker: false,
  currentCountry: "",
  currentCurrency: "",
  allCountries: [],
  fullRender: false
};
MainNavigation.propTypes = {
  data: PropTypes.PropTypes.object,
  userGender: PropTypes.string,
  showCountryPicker: PropTypes.bool,
  currentCountry: PropTypes.string,
  currentCurrency: PropTypes.string,
  allCountries: PropTypes.array,
  languageSelector: PropTypes.shape({
    is_shown: PropTypes.bool.isRequired,
    callout_text: PropTypes.string.isRequired,
    choices: PropTypes.arrayOf(LanguageChoicePropType).isRequired,
    num_columns: PropTypes.string.isRequired
  }),
  fullRender: PropTypes.bool,
  featuredDesignersUrl: PropTypes.string
};
export default withReduxProvider(MainNavigation);